import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, toDisplayString as _toDisplayString, createVNode as _createVNode, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6a39963e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "pdp-detail" }
const _hoisted_2 = { class: "swiper" }
const _hoisted_3 = ["src"]
const _hoisted_4 = { class: "custom-indicator" }
const _hoisted_5 = { class: "product-info padlr" }
const _hoisted_6 = { class: "title" }
const _hoisted_7 = { class: "desc" }
const _hoisted_8 = { class: "score" }
const _hoisted_9 = { key: 0 }
const _hoisted_10 = { class: "product-info padzero mt16 padlr" }
const _hoisted_11 = { class: "skuinfo" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "sku" }, "SKUCode", -1))
const _hoisted_13 = { class: "sku-content" }
const _hoisted_14 = { class: "skuinfo" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "商品配送", -1))
const _hoisted_16 = {
  key: 0,
  class: "skuinfo skudelivay"
}
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "兑换周期", -1))
const _hoisted_18 = { class: "product-info mt16 padlr" }
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "intro-title" }, "活动规则", -1))
const _hoisted_20 = { class: "intro-content" }
const _hoisted_21 = { class: "product-info mt16" }
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "intro-title pad16" }, "商品详情", -1))
const _hoisted_23 = { class: "intro-content" }
const _hoisted_24 = ["src"]
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "product-confirm-block" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "product-confirm-cost-block" })
], -1))
const _hoisted_26 = { class: "product-confirm" }
const _hoisted_27 = { class: "product-confirm-cost" }
const _hoisted_28 = { class: "exchange-detail" }
const _hoisted_29 = ["src"]
const _hoisted_30 = { class: "detail-info" }
const _hoisted_31 = { key: 0 }
const _hoisted_32 = { class: "exchange-operate" }
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "兑换数量", -1))
const _hoisted_34 = { class: "button" }

import { ref,onUnmounted,onActivated, watch } from 'vue';
import App from '../App.vue';
import { useStore } from 'vuex';
import { useRouter } from 'vue-router';
import { getProductDetails,verifyStock } from '@/server/api';
import { showToast } from 'vant';


export default /*#__PURE__*/_defineComponent({
  __name: 'Detail',
  setup(__props) {

const $router = useRouter();
const unconvertible = ref(0);
const showBottom = ref(false);
const exchangeNum = ref(1);
const store = useStore();  // 该方法用于返回store 实例
const titalScore = ref(6000);
const skuCode = ref('');
const details = ref({
    photoUrls : '',
    productName: '',
    description: '',
    points: 0,
    userFreightPoints: 0,
    productCode: '',
    distributionDesc: '',
    startTime: '',
    endTime: '',
    descUrl: '',
    activityRule: '',
    masterDiagramUrl: ''
});
const isExchangeStatus = ref(true);
const customLevel = ref('');
const totalPoint = ref(0)

watch(exchangeNum, (newValue, oldValue) => {
    console.log('值发生了变更', newValue, oldValue);
    
    if((store.state.totalPoint ? store.state.totalPoint : totalPoint.value) < (newValue * details.value.points + (details.value.userFreightPoints ?? 0))) {
        showToast('很抱歉，您的积分不足，请选择其他商品');
        isExchangeStatus.value = false;
    }else {
        isExchangeStatus.value = true;
    }
},{ deep: true });

onActivated(() => {
    store.dispatch("setExchangeDetails", {})
    unconvertible.value = Number($router.currentRoute.value.query?.unconvertible);
    skuCode.value = $router.currentRoute.value.query?.id as string;
    customLevel.value = $router.currentRoute.value.query?.customLevel as string;
    totalPoint.value = Number($router.currentRoute.value.query?.totalPoint)
    showBottom.value = false;
    getDetails()
})

onUnmounted(() => {
    // unconvertible.value = Number($router.currentRoute.value.query?.unconvertible);
    // skuCode.value = $router.currentRoute.value.query?.id as string;
})

const getDetails = async() => {
    const custom = !customLevel.value || customLevel.value == 'null'? {} : {
        customLevel: customLevel.value
    }
    const params = {
        skuCode: skuCode.value,
        ...custom
    }
    
    const { data } = await getProductDetails(params);
    data.startTime = data.startTime ? data.startTime.replace(new RegExp('-', 'g') , '.').substring(0,16) : '';
    data.endTime = data.endTime ? data.endTime.replace(new RegExp('-', 'g') , '.').substring(0,16)  : '';
    details.value = data;
    console.log(data)
}

const convertScore = () => {
    if (unconvertible.value) return;
    showBottom.value = true;
}

const exchangeSubmit = async() => {
    if (!isExchangeStatus.value) {
        showToast('很抱歉，您的积分不足，请选择其他商品');
    }else {
        const res = await verifyStock({
            quantity: exchangeNum.value,
            skuCode: details.value.productCode,
            customLevel: customLevel.value,
            totalPoint: totalPoint.value,
            expressPoints: details.value.userFreightPoints
        })

        if(!res?.errorCode) {
            const product = {
                productCode: details.value.productCode,
                exchangeNum: exchangeNum.value,
                productName: details.value.productName,
                description: details.value.description,
                points: details.value.points,
                userFreightPoints: details.value.userFreightPoints,
                masterDiagramUrl: details.value?.masterDiagramUrl
            };

            store.dispatch("setExchangeDetails", product)
            window.localStorage.setItem('exchangeDetails', JSON.stringify(product))
            showBottom.value = false;
            $router.push({
                name: 'orderConfirm',
                query: {
                    customLevel: customLevel.value,
                }
            })
        }else {
            showToast(res.errorMessage)
        }
    }
}


return (_ctx: any,_cache: any) => {
  const _component_van_swipe_item = _resolveComponent("van-swipe-item")!
  const _component_van_swipe = _resolveComponent("van-swipe")!
  const _component_van_stepper = _resolveComponent("van-stepper")!
  const _component_van_button = _resolveComponent("van-button")!
  const _component_van_popup = _resolveComponent("van-popup")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_van_swipe, null, {
        indicator: _withCtx(({ active, total }) => [
          _createElementVNode("div", _hoisted_4, _toDisplayString(active + 1) + "/" + _toDisplayString(total), 1)
        ]),
        default: _withCtx(() => [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(details.value.photoUrls, (item, index) => {
            return (_openBlock(), _createBlock(_component_van_swipe_item, { key: index }, {
              default: _withCtx(() => [
                _createElementVNode("img", { src: item }, null, 8, _hoisted_3)
              ]),
              _: 2
            }, 1024))
          }), 128))
        ]),
        _: 1
      })
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("p", _hoisted_6, _toDisplayString(details.value.productName), 1),
      _createElementVNode("p", _hoisted_7, _toDisplayString(details.value.description), 1),
      _createElementVNode("p", _hoisted_8, [
        _createElementVNode("span", null, _toDisplayString(details.value.points ? (details.value.points + details.value.userFreightPoints) : 0), 1),
        _createTextVNode("积分"),
        (details.value.userFreightPoints)
          ? (_openBlock(), _createElementBlock("em", _hoisted_9, "（商品积分+运费积分）"))
          : _createCommentVNode("", true)
      ])
    ]),
    _createElementVNode("div", _hoisted_10, [
      _createElementVNode("p", _hoisted_11, [
        _hoisted_12,
        _createElementVNode("span", _hoisted_13, _toDisplayString(details.value.productCode), 1)
      ]),
      _createElementVNode("p", _hoisted_14, [
        _hoisted_15,
        _createTextVNode(_toDisplayString(details.value.distributionDesc), 1)
      ]),
      (details.value.startTime && details.value.endTime)
        ? (_openBlock(), _createElementBlock("p", _hoisted_16, [
            _hoisted_17,
            _createTextVNode(_toDisplayString(details.value.startTime) + " ~ " + _toDisplayString(details.value.endTime), 1)
          ]))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_18, [
      _hoisted_19,
      _createElementVNode("p", _hoisted_20, _toDisplayString(details.value.activityRule), 1)
    ]),
    _createElementVNode("div", _hoisted_21, [
      _hoisted_22,
      _createElementVNode("div", _hoisted_23, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(details.value.descUrl, (item, index) => {
          return (_openBlock(), _createElementBlock("img", {
            key: index,
            src: item
          }, null, 8, _hoisted_24))
        }), 128))
      ])
    ]),
    _hoisted_25,
    _createElementVNode("div", _hoisted_26, [
      _createElementVNode("div", _hoisted_27, [
        _createElementVNode("button", {
          onClick: convertScore,
          class: _normalizeClass(['button', unconvertible.value || details.value.remainingQuantity === 0 ? 'gray': ''])
        }, _toDisplayString(details.value.remainingQuantity === 0 ? '缺 货' : unconvertible.value ? '积分不足' : '立即兑换'), 3)
      ])
    ]),
    _createVNode(_component_van_popup, {
      show: showBottom.value,
      "onUpdate:show": _cache[1] || (_cache[1] = ($event: any) => ((showBottom).value = $event)),
      closeable: "",
      round: "",
      position: "bottom",
      class: "exchange-product",
      style: { height: '60%' }
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_28, [
          _createElementVNode("img", {
            src: details.value.masterDiagramUrl
          }, null, 8, _hoisted_29),
          _createElementVNode("div", _hoisted_30, [
            _createElementVNode("p", null, _toDisplayString(details.value.productName), 1),
            _createElementVNode("p", null, _toDisplayString(details.value.description), 1),
            _createElementVNode("p", null, [
              _createElementVNode("span", null, _toDisplayString(details.value.points ? (details.value.points + details.value.userFreightPoints) : 0), 1),
              _createTextVNode("积分"),
              (details.value.userFreightPoints)
                ? (_openBlock(), _createElementBlock("em", _hoisted_31, "（商品积分+运费积分）"))
                : _createCommentVNode("", true)
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_32, [
          _hoisted_33,
          _createElementVNode("p", null, [
            _createVNode(_component_van_stepper, {
              modelValue: exchangeNum.value,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((exchangeNum).value = $event)),
              theme: "round",
              "button-size": "22",
              "disable-input": ""
            }, null, 8, ["modelValue"])
          ])
        ]),
        _createElementVNode("div", _hoisted_34, [
          _createVNode(_component_van_button, {
            onClick: exchangeSubmit,
            round: "",
            block: "",
            type: "primary",
            color: "#FF3469"
          }, {
            default: _withCtx(() => [
              _createTextVNode("确 认")
            ]),
            _: 1
          })
        ])
      ]),
      _: 1
    }, 8, ["show"])
  ]))
}
}

})